const variantId = id => btoa(`gid://shopify/ProductVariant/${id}`);

const decodeVariantId = id => atob(id).match(/gid:\/\/shopify\/ProductVariant\/(.*)/)[1];

export { variantId, decodeVariantId };



// WEBPACK FOOTER //
// ./src/shopify-ids.js